import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h4-bold",
  "use": "icon-h4-bold-usage",
  "viewBox": "0 0 21 25",
  "content": "<symbol viewBox=\"0 0 21 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h4-bold\">\n<path d=\"M1.26 6.148V19H3.366V13.312H9.882V19H11.988V6.148H9.882V11.512H3.366V6.148H1.26Z\" fill=\"#323232\" />\n<path d=\"M18.68 11.88L15.19 16.38V17.49H18.64V19.02H19.75V17.49H20.81V16.56H19.75V11.88H18.68ZM18.61 13.36H18.64V16.56H16.14L18.61 13.36Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol